import { CertificazioneCompetenzeStato } from ".";

export class CertificazioneCompetenzeStudente {
    id!: string;
    studenteId!: string;
    studenteNome!: string;
    studenteCognome!: string;
    stato!: CertificazioneCompetenzeStato;
}